import { AdminType, APIPost, APIUrl, IAPIResponse } from "api/protocols";

export async function PostMarkdownImage(
  image: File,
  adminType: AdminType,
): Promise<IAPIResponse<{ source: string }>> {
  const formData = new FormData();
  formData.append("image", image);
  return await APIPost(APIUrl(adminType, "/markdown/image"), formData, false);
}
